module.exports = __webpack_public_path__ + "img/SES_120260001.2f67bffc.jpg";